'use es6';

import { RAW_ASSET, CSS as FOLDER_ASSET_TYPE_CSS, JS, TEMPLATE } from 'DesignData/enums/FolderAssetTypes';
export default Object.freeze([RAW_ASSET, FOLDER_ASSET_TYPE_CSS, JS, TEMPLATE]);